// @vendors
const Immutable = require('immutable');

// @constants
const actionTypes = require('constants/actionTypes');
const {
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    FOURTH_STEP
} = require('constants/index');

// @reducers
const hireCardMinicardStep1 = require('./hireCardMinicard/hireCardMinicardStep1');
const hireCardMinicardStep2 = require('./hireCardMinicard/hireCardMinicardStep2');
const hireCardMinicardStep3 = require('./hireCardMinicard/hireCardMinicardStep3');
const hireCardMinicardStep4 = require('./hireCardMinicard/hireCardMinicardStep4');

const initialState = Immutable.fromJS({
    error: false,
    errorMsg: '',
    isFetching: false,
    steps: [
        hireCardMinicardStep1(),
        hireCardMinicardStep2(),
        hireCardMinicardStep3(),
        hireCardMinicardStep4()
    ],
    submitSuccessful: false,
    visibleStep: 1,
    willCancel: false,
    allAccountsInactive: false,
    loadingFlag:false
});

function updateStep(index, steps, action) {
    return steps.update(index, step => {
        switch (index) {
            case FIRST_STEP:
                return hireCardMinicardStep1(step, action);
            case SECOND_STEP:
                return hireCardMinicardStep2(step, action);
            case THIRD_STEP:
                return hireCardMinicardStep3(step, action);
            case FOURTH_STEP:
                return hireCardMinicardStep4(step, action);
        }
    });
}

function getNextVisibleStep(partialSteps, currentStep) {
    const totalSteps = partialSteps.size;
    const stepPosition = currentStep - 1;
    let nextStep = currentStep + 1;

    if (!partialSteps.getIn([stepPosition, 'valid']) || nextStep > totalSteps){
        nextStep = currentStep;
    }

    return nextStep;
}

function hireCardMinicardReducer(state = initialState, action = { type: null }) {
    let partialSteps;
    switch (action.type) {
        case actionTypes.HIRE_CARD_MINICARD_VALIDATE_STEP:
            const currentStep = action.payload.step;
            let visibleStep;
            switch (currentStep) {
                case 1:
                    partialSteps = updateStep(FIRST_STEP, state.get('steps'), action);
                    visibleStep = getNextVisibleStep(partialSteps, currentStep);

                    return state.merge({
                        steps: partialSteps,
                        visibleStep
                    });
                case 2:
                    partialSteps = updateStep(SECOND_STEP, state.get('steps'), action);
                    visibleStep = getNextVisibleStep(partialSteps, currentStep);

                    return state.merge({
                        steps: partialSteps,
                        visibleStep
                    });
                case 3:
                    partialSteps = updateStep(THIRD_STEP, state.get('steps'), action);
                    visibleStep = getNextVisibleStep(partialSteps, currentStep);

                    return state.merge({
                        steps: partialSteps,
                        visibleStep
                    });
                case 4:
                    partialSteps = updateStep(FOURTH_STEP, state.get('steps'), action);
                    visibleStep = getNextVisibleStep(partialSteps, currentStep);

                    return state.merge({
                        steps: partialSteps,
                        visibleStep
                    });
            }
            return state;
        
            case actionTypes.HIRE_CARD_LOADING:
                return state.merge({
                    loadingFlag: action.payload.loadingFlag
                });
        case actionTypes.HIRE_CARD_MINICARD_SET_ACCOUNT:
            return state.merge({
                steps: updateStep(SECOND_STEP, state.get('steps'), action),
            });

        case actionTypes.HIRE_CARD_MINICARD_SET_ALL_ACCOUNTS_TO_INACTIVE:
            return state.merge({
                allAccountsInactive: true
            });

        case actionTypes.HIRE_CARD_MINICARD_SET_AGREEMENT_CHECKBOX:
            const stepToUpdate = __CONTACT_CENTER__ ? FIRST_STEP : FOURTH_STEP;
            return state.merge({
                steps: updateStep(stepToUpdate, state.get('steps'), action)
            });

        case actionTypes.HIRE_CARD_MINICARD_SET_VISIBLE_STEP:
            return state.merge({
                visibleStep: action.payload.step
            });

        case actionTypes.HIRE_CARD_MINICARD_WILL_CANCEL:
            return state.merge({
                willCancel: action.payload.willCancel
            });

        case actionTypes.HIRE_CARD_MINICARD_REQUEST:
            return state.merge({
                error: false,
                errorMsg: '',
                isFetching: true,
                submitSuccessful: false
            });

        case actionTypes.HIRE_CARD_MINICARD_SUCCESS:
            return state.merge({
                isFetching: false,
                submitSuccessful: true
            });

        case actionTypes.HIRE_CARD_MINICARD_FAILURE:
            return state.merge({
                error: true,
                errorMsg: action.payload.errorMsg,
                isFetching: false
            });

        case actionTypes.HIRE_CARD_MINICARD_RESET:
            return initialState;

        default:
            return state;
    }
}

module.exports = hireCardMinicardReducer;
